<template>
  <div>


    <div v-if="mode === 'SELF_REPORTED'" class="insetGraph">
      <activity-line-graph
        v-if="$store.state.user.scope"
        :userId="$store.state.user.scope.user_id"
        @onTrackingType_activity="onTrackingTypeActivity"

      >
      </activity-line-graph>
    </div>
    <div v-if="mode === 'STEPS'" class="insetGraph">
      <activity-steps-line-graph v-if="$store.state.user.scope"
                                 :userId="$store.state.user.scope.user_id"
                                 @onTrackingType_activity="onTrackingTypeActivity"></activity-steps-line-graph>
    </div>


    <div style="margin: 0 auto;text-align: center;">

    </div>

    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50">

        <activity-input class="card-spacing" style="margin-top: 24px"
                        :bmr="$store.state.user.stats.bmr"></activity-input>


        <activity-wearable-visualisation v-if="mode === 'STEPS'"></activity-wearable-visualisation>

        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px;"
          id="blood-glucose-data"
          class="tracking-data"
        >


          <mu-tabs v-model="mode">
            <mu-tab value="STEPS" @click.native="mode = 'STEPS'">{{$t('message.labelSteps').charAt(0).toUpperCase() + $t('message.labelSteps').substr(1)}}</mu-tab>
            <mu-tab value="SELF_REPORTED" @click.native="mode = 'SELF_REPORTED'">{{$t('message.labelManualEntry')}}</mu-tab>
          </mu-tabs>


          <div v-if="mode === 'SELF_REPORTED'">
            <mu-timeline>


              <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
                <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                     class="timelineSpacing">
                  <div class="bold timelineTitle groupedDate"
                       v-text="groupedDateFormat(titleItem.date_created)">
                  </div>
                </div>
                <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index"
                     v-bind:class="{notEditMode: !item.isEditMode}">
                  <mu-timeline-item
                    :iconColor="btnColor"
                    iconLine="8"
                    iconType="solid"
                    @click.native="showItemControls(item)"
                  >
                    <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                      <mu-row>
                        <mu-col>
                          <div class="trackingDate" v-if="!item.isEditMode"
                               v-text="groupedItemDate(item.date_created)"></div>
                          <div>{{$t('message.labelActivityType')}}: {{getLocaleLabel(item.type)}}</div>
                          <div>{{$t('message.labelCaloriesBurnt')}}: {{item.calories_burnt}} kcal</div>
                        </mu-col>
                        <mu-col>
                          <div v-if="!item.isEditMode" class="reading">
                            {{item.minutes}} {{$t('message.labelMinute')}}
                          </div>
                        </mu-col>
                      </mu-row>
                    </div>
                    <div v-if="item.isControlsVisible === true && !item.isEditMode">
                      <mu-flat-button
                        :color="btnColor"
                        :label="$t('message.deleteText')"
                        icon="delete"
                        @click.native="deleteReading(item)"
                      ></mu-flat-button>
                    </div>
                  </mu-timeline-item>
                </div>
              </div>

              <mu-card-text align=" center" v-if="isReadingsLoading">
                <mu-circular-progress color="#0179d5"></mu-circular-progress>
                <div>{{$t('message.loadingText')}}</div>
              </mu-card-text>
              <div v-if="!isReadingsLoading" ref="detector"></div>
            </mu-timeline>
          </div>


          <div v-if="mode === 'STEPS'">
            <mu-timeline>


              <mu-content-block v-if="data.data.length === 0 && !isReadingsLoading"
                                style="text-align: center;padding-bottom: 24px;">
      <!--
                <h3>{{$t('message.activityStepsEmptyTitle')}}</h3>
                <p>{{$t('message.activityStepsEmptySubTitle')}}</p>
                <mu-raised-button @click.native="getStartedIntegrations"
                                  :label="$t('message.activityStepsEmptyButton')"></mu-raised-button>
                                  -->

                <h3>You don't have any steps data yet</h3>
                <p>To get started connect your favorite health app below</p>
                <mu-raised-button @click.native="getStartedIntegrations"
                                  label="Add an activity integration"></mu-raised-button>
              </mu-content-block>


              <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
                <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                     class="timelineSpacing">
                  <div class="bold timelineTitle groupedDate"
                       v-text="groupedDateFormat(titleItem.date_created)">
                  </div>
                </div>
                <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index"
                     v-bind:class="{notEditMode: !item.isEditMode}">
                  <mu-timeline-item
                    :iconColor="btnColor"
                    iconLine="8"
                    iconType="solid"
                  >
                    <div v-if="!item.isEditMode" v-bind:class="{spacingBottom: item.isControlsVisible}">
                      <mu-row>
                        <mu-col>
                          <div class="trackingDate" v-if="!item.isEditMode"
                               v-text="groupedStepDate(item.date_created)"></div>
                          <span><img style="position:relative; top:8px;margin-right: 8px;" width="24"
                                     src="static/ic_watch_activity.svg">{{item.device}}</span>
                          <span><img style="position:relative; top:8px;margin-right: 8px;" width="24"
                                     src="static/ic_hk_activity.svg">{{$t('message.labelCaloriesBurnt')}}: {{numberFormat(item.calories)}} kcal</span>
                          <div><img style="position:relative; top:8px;margin-right: 8px;" width="24"
                                    src="static/ic_floors_climbed.svg"> {{$t('message.labelFloorsClimbed')}}:
                            {{item.floors}}
                          </div>

                        </mu-col>
                        <mu-col>
                          <div class="reading">{{numberFormat(item.steps)}} {{$t('message.labelSteps')}}</div>
                        </mu-col>
                      </mu-row>
                    </div>
                  </mu-timeline-item>
                </div>
              </div>

              <mu-card-text align=" center" v-if="isReadingsLoading">
                <mu-circular-progress color="#0179d5"></mu-circular-progress>
                <div>{{$t('message.loadingText')}}</div>
              </mu-card-text>
              <div v-if="!isReadingsLoading" ref="detector"></div>
            </mu-timeline>
          </div>


        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>
  import config from '../../config'


  import TrackingDetailMixin from '../../mixins/TrackingDetailMixin'
  import numeral from 'numeral'
  import ActivityApi from '../../api/Tracking/Activity'
  import IntegrationApi from '../../api/Integrations'
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";
  import ActivityInput from "../../components/Tracking/Input/Activity/Activity";
  import ActivityLineGraph from "../../components/Tracking/Graphs/Activity/LineGraph";
  import activityTypes from '../../components/Tracking/activityTypes'
  import ServiceTrackingTypes from "../../components/Tracking/ServiceTrackingTypes/ServiceTrackingTypes";

  import ActivityStepsLineGraph from "../../components/Tracking/Graphs/ActivitySteps/LineGraph";


  import ActivityWearableVisualisation from "../../components/Tracking/Visualizations/Activity/WearableVisualisation";

  export default {
    mixins: [TrackingDetailMixin],
    components: {
      ActivityWearableVisualisation,
      ActivityStepsLineGraph,
      ServiceTrackingTypes,
      ActivityLineGraph,
      ActivityInput,
      TrackingExporter,
      TrackingNotifier
    },
    data() {
      return {
        btnColor: '#4f2bb4',
        activityTypes: activityTypes,
        mode: 'STEPS',
        modes: [
          {
            name: 'Manual logs',
            value: 'SELF_REPORTED'
          },
          {
            name: 'Steps',
            value: 'STEPS'
          }
        ]
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/activity');
      self.loadData();

      IntegrationApi.available.activity()
        .then(function (response) {
          if (response.data.length > 0) {
          }
        });

      self.$EventBus.$on('activityPusherReceived', function () {
        self.loadData();
      });
    },
    watch: {
      'mode': function () {
        let self = this;
        self.data.page = 1;
        self.data.page_size = 15;
        self.data.data = [];
        self.isReadingsLoading = true;
        if (self.mode === 'SELF_REPORTED') {
          ActivityApi.getActivityTrackingDetail(1, 15)
            .then(function (response) {
              self.isReadingsLoading = false;
              self.data = response.data;
              self.$forceUpdate();
            })
        }

        if (self.mode === 'STEPS') {
          ActivityApi.getActivityStepsTrackingDetail(1, 15)
            .then(function (response) {
              self.isReadingsLoading = false;
              self.data = response.data;
              self.$forceUpdate();
            })
        }
      }
    },
    methods: {
      numberFormat(num) {
        let number = numeral(num);
        return number.format();
      },
      getStartedIntegrations() {
        let self = this;
        self.$router.push({
          name: 'SettingsIntegrations'
        })
      },
      groupedStepDate(date) {
        let offset = new Date();
        let dateMod = moment.utc(date).locale(config.language);
        return dateMod.format('dddd Do');
      },
      getLocaleLabel(key) {
        let self = this;
        let activeKey = self.activityTypes.filter(function (item) {
          return item.value === key
        })[0];
        return self.$t(activeKey.locale);
      },
      deleteReading(reading) {
        let self = this;
        let swal = self.$alert;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmRemoveActivityItem'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return ActivityApi.deleteActivityReading(reading.progress_id, reading.tracking_id)
          }
        })
          .then(function (response) {
            let index = self.data.data.indexOf(reading);
            self.data.data.splice(index, 1);
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedRemoveActivityItem'),
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "white"
            })

          }.bind(self))
          .catch(self.$alert.noop)
      },
      loadData() {
        let self = this;

        if (self.mode === 'SELF_REPORTED') {
          ActivityApi.getActivityTrackingDetail(1, 15)
            .then(function (response) {
              self.isReadingsLoading = false;
              self.data = response.data;
              self.$forceUpdate();
            })
        }

        if (self.mode === 'STEPS') {
          ActivityApi.getActivityStepsTrackingDetail(1, 15)
            .then(function (response) {
              self.isReadingsLoading = false;
              self.data = response.data;
              self.$forceUpdate();
            })
        }
      },
      loadMoreData() {
        let self = this, page = self.data.page, pages = self.data.pages;
        if (page >= pages) {
          self.isReadingsLoading = false;
          return;
        }
        if ((page < pages)) {
          self.isReadingsLoading = true;

          if (self.mode === 'SELF_REPORTED') {
            page++;
            ActivityApi.getActivityTrackingDetail(page, 15)
              .then(function (response) {
                self.data.page = response.data.page;
                self.data.data.push.apply(self.data.data, response.data.data);
                self.isReadingsLoading = false;
              })
          }
          if (self.mode === 'STEPS') {
            page++;
            ActivityApi.getActivityStepsTrackingDetail(page, 15)
              .then(function (response) {
                self.data.page = response.data.page;
                self.data.data.push.apply(self.data.data, response.data.data);
                self.isReadingsLoading = false;

              })
          }
        }
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('activityReadingAdded');
      this.$EventBus.$off('activityReadingReceived')
    }
  }
</script>
<style scoped lang="less">


  @bgBranding: #4e2288;

  .timelineSpacing.notEditMode:hover {
    background: fade(@bgBranding, 10%);
    cursor: pointer;
  }

  .whiteTitle {
    font-size: 18px !important;
    color: white !important;

  }
</style>



// WEBPACK FOOTER //
// Activity.vue?6ee06d94